import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SITE } from "../lib/api";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative pt-28 md:pt-36 pb-16 md:pb-24 bg-[#FAF9F6] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        {/* Left: Text */}
        <div className="lg:col-span-7 order-2 lg:order-1">
          <div className="reveal flex items-center text-[11px] md:text-xs uppercase tracking-[0.28em] text-[#003F88] font-medium">
            <span className="accent-line" />
            Lauro de Freitas · Bahia · {SITE.party}
          </div>

          <h1
            data-testid="hero-headline"
            className="reveal reveal-delay-1 font-serif-display text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight text-neutral-900 mt-6 md:mt-8"
          >
            Homem que <em className="italic font-light">honra</em>
            <br />
            sua palavra.
          </h1>

          <p
            data-testid="hero-subhead"
            className="reveal reveal-delay-2 mt-6 md:mt-8 max-w-xl text-base md:text-lg leading-relaxed text-neutral-600 font-light"
          >
            Procurador Municipal concursado. Três mandatos como vereador e três passagens pela
            presidência da Câmara Municipal de Lauro de Freitas. Ex-Secretário da SEDUR — uma
            trajetória administrativa, jurídica e política a serviço da cidade.
          </p>

          <div className="reveal reveal-delay-3 mt-8 md:mt-10 flex flex-wrap items-center gap-4">
            <Link
              to="/projetos"
              data-testid="hero-cta-primary"
              className="inline-flex items-center gap-3 bg-[#003F88] text-white px-7 py-4 text-xs uppercase tracking-[0.2em] font-medium hover:bg-[#002A5C] transition-colors"
            >
              Conheça os projetos
              <ArrowRight size={16} />
            </Link>
            <Link
              to="/trajetoria"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center gap-3 border-2 border-[#003F88] text-[#003F88] px-7 py-[14px] text-xs uppercase tracking-[0.2em] font-medium hover:bg-[#003F88] hover:text-white transition-colors"
            >
              Trajetória política
            </Link>
          </div>

          {/* stats */}
          <div className="reveal reveal-delay-4 mt-12 md:mt-16 grid grid-cols-3 gap-6 md:gap-10 max-w-xl">
            {[
              { n: "3", l: "mandatos como vereador" },
              { n: "3x", l: "presidente da câmara" },
              { n: "17", l: "áreas de atuação" },
            ].map((s) => (
              <div key={s.l} data-testid={`hero-stat-${s.l.split(" ")[0]}`}>
                <div className="font-serif-display text-4xl md:text-5xl font-semibold text-[#003F88] leading-none">
                  {s.n}
                </div>
                <div className="mt-2 text-[11px] md:text-xs uppercase tracking-widest text-neutral-500">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right: Editorial Photo */}
        <div className="lg:col-span-5 order-1 lg:order-2 relative">
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-20 h-20 bg-[#FFC72C] z-0" />
            <div className="absolute -bottom-8 -right-6 w-32 h-1 bg-[#003F88] z-0 hidden md:block" />
            <div className="relative z-10 overflow-hidden bg-neutral-200">
              <img
                src="/photos/hero-portrait.jpg"
                alt="Antônio Rosalvo"
                data-testid="hero-portrait"
                className="editorial-img w-full h-[460px] md:h-[560px] lg:h-[640px] object-cover"
              />
            </div>
            <div className="relative z-10 mt-4 flex items-center justify-between text-xs uppercase tracking-widest text-neutral-500">
              <span>Foto · arquivo pessoal</span>
              <span>{SITE.instagramHandle}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
